import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import { subscriptionFragment } from "@saleor/fragments/subscribers";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { CountAllSubscriptions } from "./types/CountAllSubscriptions"
import {
  SubscriptionDetails,
  SubscriptionDetailsVariables
} from "./types/SubscriptionDetails";
import {
  SubscriptionList,
  SubscriptionListVariables
} from "./types/SubscriptionList";

const subscriptionList = gql`
  ${subscriptionFragment}
  ${pageInfoFragment}
  query SubscriptionList(
    $filter: SubscriptionFilterInput
    $before: String
    $after: String
    $first: Int
    $last: Int
    $sort: SubscriptionSortingInput
  ) {
    subscriptions(
      filter: $filter
      before: $before
      after: $after
      first: $first
      last: $last
      sortBy: $sort
    ) {
      totalCount
      edges {
        node {
          ...SubscriptionFragment
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
      totalCount
    }
  }
`;

export const useSubscriptionListQuery = makeQuery<
  SubscriptionList,
  SubscriptionListVariables
>(subscriptionList);


const countAllSubscriptionsQuery = gql`
  query CountAllSubscriptions {
    subscriptions {
      totalCount
    }
  }
`;

export const useCountAllSubscriptions = makeQuery<CountAllSubscriptions, null>(
  countAllSubscriptionsQuery
);


const subscriptionDetails = gql`
  ${subscriptionFragment}
  query SubscriptionDetails($id: ID!) {
    subscription(id: $id) {
      ...SubscriptionFragment
    }
  }
`;

export const useSubscriptionDetailsQuery = makeQuery<
  SubscriptionDetails,
  SubscriptionDetailsVariables
>(subscriptionDetails);
